import * as actions from 'actions/ActionTree';

export  default  function tree(state = {tree: []}, action){
	switch (action.type){
		case actions.TREE_ADD:
			return Object.assign({}, state, {tree: [... state.tree, action.item]});
		case actions.TREE_EDIT:
			let stateBuf =  state.tree.map(item => {
				if(item.id === action.id){
					return Object.assign({}, item, {
						title: action.title,
						parent_id: action.parent_id
					});
				}
				return item;
			});
			return Object.assign({}, stateBuf);
		case actions.TREE_REMOVE:
			return Object.assign({}, state, {
				tree: state.tree.filter(item => action.id !== item.id)
			});
		case actions.TREE_UPDATE_ALL:
			return Object.assign({}, state, {
				tree: action.tree
			});
		default:
			return state;
	}
}






// WEBPACK FOOTER //
// ./frontend/reducers/end_categories.js